<template>
    <div class="content">

        <div class="col-12 float-left">
            <b-alert v-for="alert in alerts" show class="mb-3" :variant="alert.alertTypeClass" dismissible>
                {{ alert.caption }}
            </b-alert>
        </div>

        <b-overlay :show="loading"
                   class="col-6 mb-2 col-md-4 col-lg-3 float-dynamic">
            <div class="dashboard-card bg-pink text-dark">
                <label class="font-weight-bold d-block mb-3">موجودی کارت</label>
                <strong class="d-block money number mb-3">
                    {{
                        new Intl.NumberFormat().format(leftCharge)
                    }}
                </strong>
                <small>موجودی کارت شما</small>
            </div>
        </b-overlay>
        <b-overlay :show="loading"
                   class="col-6 mb-2 col-md-4 col-lg-3 float-dynamic">
            <div class="dashboard-card bg-pink text-dark">
                <label class="font-weight-bold d-block mb-3">شارژ اولیه</label>
                <strong class="d-block money number mb-3">0</strong>
                <small>مبلغ شارژ اولیه</small>
            </div>
        </b-overlay>
        <b-overlay :show="loading"
                   class="col-6 mb-2 col-md-4 col-lg-3 float-dynamic">
            <div class="dashboard-card bg-pink text-dark">
                <label class="font-weight-bold d-block mb-3">مبلغ مانده اقساط</label>
                <strong class="d-block money number mb-3">
                    {{
                        new Intl.NumberFormat().format(debtAmount)
                    }}
                </strong>
                <small>مبلغ کل مانده اقساط</small>
            </div>
        </b-overlay>
        <b-overlay :show="loading"
                   class="col-6 mb-2 col-md-4 col-lg-3 float-dynamic">
            <div class="dashboard-card bg-pink text-dark">
                <label class="font-weight-bold d-block mb-3">تعداد تراکنش ها</label>
                <strong class="d-block money number mb-3">
                    {{
                        new Intl.NumberFormat().format(totalTransactions)
                    }}
                </strong>
                <small>تعداد کل تراکنش ها</small>
            </div>
        </b-overlay>
        <b-overlay :show="loading" class="col-12 mb-3 float-dynamic">
            <div class="dashboard-card bg-white">
                <div class="col-12 text-left">
                    <font-awesome-icon @click="transactionChartType = 'line-chart'"
                                       class="mr-2 ml-2 pointer pink"
                                       icon="chart-line" />
                    <font-awesome-icon @click="transactionChartType = 'area-chart'"
                                       class="mr-2 ml-2 pointer pink"
                                       icon="chart-area" />
                    <font-awesome-icon @click="transactionChartType = 'column-chart'"
                                       class="mr-2 ml-2 pointer pink"
                                       icon="chart-bar" />
                </div>
                <label class="text-muted text-right font-weight-bold d-block mb-3">نمودار تعداد تراکنش ها به تفکیک هر ماه</label>
                <component v-bind:is="transactionChartType"
                           :download="true"
                           :colors="['#f5c842']"
                           :data="transactionChart"></component>
            </div>
        </b-overlay>
        <b-overlay :show="loading" class="col-12 mb-3 float-dynamic">
            <div class="dashboard-card bg-white">
                <div class="col-12 text-left">
                    <font-awesome-icon v-for="chartType in chartTypes"
                                       @click="transactionSplitChartType = chartType.name"
                                       class="mr-2 ml-2 pointer pink"
                                       :icon="chartType.icon" />
                </div>
                <label class="text-muted font-weight-bold d-block mb-3">نمودار مبلغ اقساط به تفکیک هر ماه</label>
                <component v-bind:is="transactionSplitChartType"
                           :download="true"
                           :colors="['#f5c842']"
                           :data="transactionSplitChart"></component>
            </div>
        </b-overlay>
    </div>
</template>
<script>
    import store from "@/store";
    export default {
        data()
        {
            return {
                loading: false,
                customer: store.customer,
                totalTransactions: 0,
                totalTransactionValues: 0,
                alerts:[],
                totalSplits: 0,
                debtAmount: 0,
                leftCharge: 0,
                transactionChart: {},
                chartTypes: [
                    { name: "line-chart", icon: "chart-line" },
                    { name: "area-chart", icon: "chart-area" },
                    { name: "column-chart", icon: "chart-bar"}
                ],
                transactionChartType: "line-chart",
                transactionSplitChart: {},
                transactionSplitChartType: "column-chart"
            };
        },

        beforeMount()
        {
            this.initDashboard();
        },

        methods: {
            initDashboard()
            {
                this.loading = true;

                axios({ method: "post", url: "/api/App/GetDashboardReport" })
                    .then(response =>
                    {
                        this.totalTransactions = response.data.meta.totalTransactions;
                        this.totalTransactionValues =
                            response.data.meta.totalTransactionValues;
                        this.totalSplits = response.data.meta.totalSplits;
                        this.leftCharge = response.data.meta.leftCharge;
                        this.debtAmount = response.data.meta.debtAmount;
                        this.transactionChart = response.data.meta.transactionChart;
                        this.transactionSplitChart = response.data.meta.transactionSplitChart;
                        this.alerts = response.data.meta.alerts;
                        this.loading = false;
                    })
                    .catch(error => { });
            }
        }
    };
</script>
<style>
    .card,
    .dashboard-card {
        border-radius: 10px;
    }

    .dashboard-card {
        min-height: 100px;
        text-align: center;
        padding: 20px;
        margin-bottom: 20px;
        box-shadow: 0 1px 3px 0 rgba(221, 221, 221, 1);
    }

        .dashboard-card .number {
            font-size: 20px;
        }
</style>
